var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createBasicColorSet, cssColorValue, KeyboardDetectionProvider, screenLgMax, screenMdMax, screenSmMax, screenXxsMax, spacer24, spacer32, spacer40, spacer48, spacer56, } from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';
import { ButtonPrimaryLink, Grid, VideoPlayer, } from '../../ui';
import { ColorSetWrapper } from '../../ui/Colors/Colors';
import { SectionHeader, } from '../../ui/Components/SectionHeader';
import { fixHref } from '../../ui/utils';
const Wrapper = styled(Grid) `
  padding-top: ${spacer48};
  padding-bottom: ${({ bottomText }) => (bottomText ? spacer56 : spacer48)};
  @media (max-width: 1439px) {
    padding-top: ${spacer40};
    padding-bottom: ${({ bottomText }) => (bottomText ? spacer48 : spacer40)};
  }
  @media (max-width: ${screenXxsMax}) {
    padding-top: ${spacer24};
    padding-bottom: ${({ bottomText }) => (bottomText ? spacer48 : spacer24)};
  }
  .cta {
    display: flex;
    width: 100%;
    justify-content: start;
    @media (max-width: ${screenXxsMax}) {
      justify-content: center;
    }
  }
`;
const VideoWrapper = styled.div `
  grid-column: 1 / -1;
  overflow: hidden;
`;
const TextWrapper = styled.div `
  padding-top: ${spacer32};
  grid-column: 1 / 7;
  @media (max-width: ${screenLgMax}) {
    grid-column: 1 / 8;
  }
  @media (max-width: ${screenMdMax}) {
    grid-column: 1 / 9;
  }
  @media (max-width: ${screenSmMax}) {
    grid-column: 1 / -1;
  }
`;
export const FullWidthVideoModule = React.forwardRef((_a, ref) => {
    var { video, ctaUrl, ctaText, ctaOpenNewTab, colors } = _a, sectionHeadingProps = __rest(_a, ["video", "ctaUrl", "ctaText", "ctaOpenNewTab", "colors"]);
    const { heading, body, eyebrow, subhead } = sectionHeadingProps;
    const useSectionHeader = heading || body || eyebrow || subhead || (ctaText && ctaUrl);
    if (!video) {
        return null;
    }
    return (React.createElement(KeyboardDetectionProvider, null,
        React.createElement(ColorSetWrapper, { colors: colors },
            React.createElement(Wrapper, { bottomText: useSectionHeader ? true : false, ref: ref },
                React.createElement(VideoWrapper, { id: "video" },
                    React.createElement(VideoPlayer, Object.assign({}, video))),
                useSectionHeader && (React.createElement(TextWrapper, null,
                    React.createElement(SectionHeader, Object.assign({}, sectionHeadingProps, { cta: ctaText && (React.createElement(ButtonPrimaryLink, { dataTestId: `cta-${ctaText}`, UNSAFE_colorSet: createBasicColorSet((colors === null || colors === void 0 ? void 0 : colors.textColor) || cssColorValue('textBase'), (colors === null || colors === void 0 ? void 0 : colors.backgroundColor) ||
                                cssColorValue('backgroundBase')), target: ctaOpenNewTab ? '_blank' : '_self', href: fixHref(ctaUrl), track: [
                                'module-fullWidthVideoModule',
                                `CTA Link - ${ctaText}`,
                            ] }, ctaText)) }))))))));
});
//# sourceMappingURL=index.js.map